import { render, staticRenderFns } from "./softwareLis.vue?vue&type=template&id=27726136&scoped=true&"
import script from "./softwareLis.vue?vue&type=script&lang=ts&"
export * from "./softwareLis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27726136",
  null
  
)

export default component.exports